import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import Loader from './components/common/loader';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <BrowserRouter>
    // <React.StrictMode>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    // </React.StrictMode>
  // </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for automatic updates and offline support
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New version available! Updating...');
  },
  onSuccess: (registration) => {
    console.log('App is ready for offline use.');
  }
});
